module.exports = __webpack_public_path__ + "img/P150T_weapon_34.1245b59f.png";